import { TicketData } from '@/common/types/support/ticket.type'
import { cn } from '@/common/utils/cn'
import { strategy as externalSupportStatusStrategy } from '@/features/support/external/constants/statusOptions.constant'
import { supportStatusStrategy as internalSupportStatusStrategy } from '@/features/support/internal/constants/supportStatusOptions.constant'

type SupportTicketStatusProps = {
  ticketType: TicketData['ticket_type']
  status: TicketData['status']
}

export const SupportTicketStatus = ({ ticketType, status }: SupportTicketStatusProps) => {
  const statusStrategy = ticketType === 'internal' ? internalSupportStatusStrategy : externalSupportStatusStrategy

  return (
    <p className={cn(status === 'pending' && 'text-danger-soft')}>
      {statusStrategy[status as keyof typeof statusStrategy] || '--'}
    </p>
  )
}
